<template>
  <vs-table :data="data">
    <template slot="header">
      <add-button @click="add" :btnText="$t('bank_account')" v-show="hasPermission(['IU BANK ACCOUNT EDIT'])"/>
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-filter"
        class="mx-2"
        radius
        @click="filter"
      ></vs-button>
    </template>
    <template slot="thead">
      <!-- <th class="qb-sticky" :style="{background:'white'}"></th> -->
      <th-sort
        :text="$t('client')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('bank')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th-sort
        :text="$t('account')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th class="qb-sticky" :style="{ background: 'white' }"></th>
      <th-sort
        :text="$t('currency')"
        column="Cl.ShortName"
        @sort="handleClickSort"
      />
      <th class="qb-sticky">
        {{ $t('actions') }}
      </th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].client_name }}
        </vs-td>
        <vs-td>
          {{ data[i].bank_short_name }}
        </vs-td>
        <vs-td>
          {{ data[i].number }}
        </vs-td>
        <vs-td>
          <vs-chip
            v-if="data[i].cash_request == '1'"
            color=" #d7dbdd"
            style="color: #626262"
            >{{ $t('cash_request') }}</vs-chip
          >
        </vs-td>
        <vs-td>
          {{ data[i].currency }}
        </vs-td>
        <vs-td>
          <div>
            <!-- <action-pdf-viewer :files="[data[i].file]"/> -->
            <action-icon
              icon="EditIcon"
              :tooltip="$t('edit')"
              @click="edit(data[i])"
            />
            <!-- <action-icon icon="FileIcon" :tooltip="$t('file')" /> -->
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import ActionPdfViewer from '@/views/components/actions/ActionPdfViewer'
import mixins from '@/mixins'
import AddButton from '@/views/components/buttons/AddButton.vue'
export default {
  components: {
    ActionIcon,
    ThSort,
    ActionPdfViewer,
    AddButton,
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    filter() {
      this.$emit('filter')
    },
    add() {
      this.$emit('add')
    },
    edit(account) {
      this.$emit('edit', account)
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>